import Route from '@ember/routing/route';
import { service } from '@ember/service';
import SessionService from 'bcl/services/session';
import Store from '@ember-data/store';
import RSVP from 'rsvp';

export default class BasicDataRoute extends Route {
  @service declare store: Store;
  @service declare session: SessionService;

  _getLocations() {
    const locations = [...this.store.peekAll('location')];
    locations.sort((a, b) => a.name?.localeCompare(b.name));
    return locations;
  }
  _getSuppliers() {
    const suppliers = [...this.store.peekAll('supplier')];
    suppliers.sort((a, b) => a.name.localeCompare(b.name));
    return suppliers;
  }
  model() {
    return RSVP.hash({
      company: this.session.company,
      items: this.store.peekAll('item'),
      locations: this._getLocations(),
      suppliers: this._getSuppliers(),
    });
  }
}
